import { useEffect, useState, useCallback } from "react";

export function shouldIgnoreShortcut(target: EventTarget | null): boolean {
  if (!target) return false;
  const el = target as Partial<HTMLElement> & { tagName?: string; isContentEditable?: boolean };
  const tag = el.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
  if (el.isContentEditable === true) return true;
  return false;
}

export function useShortcutsOverlay() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.defaultPrevented) return;
      if (e.key !== "?") return;
      if (shouldIgnoreShortcut(e.target)) return;
      e.preventDefault();
      setOpen((prev) => !prev);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  const close = useCallback(() => setOpen(false), []);
  const openOverlay = useCallback(() => setOpen(true), []);

  return { open, setOpen, close, openOverlay };
}
